import API from '@/services/GraphQl';
export const actions = {
  async getListFeatureFlags({ commit, dispatch, getters }, { forceGetting = false } = {
  }) {
    const { isEmptyFeatureFlagsList: isEmpty } = getters;
    if (forceGetting && isEmpty) return;
    if (!isEmpty && !forceGetting) return;
    try {
      const { data } = await API.listFeatureFlags();
      commit('setListFeatureFlags', data.response);
    } catch (err) {
      dispatch('handleError', err, {
        root: true,
      });
    }
  },
  async manageMaintenance({ dispatch, commit }, { enabled }) {
    try {
      commit('spinner', true, {
        root: true,
      });
      const { data } = await API.setMaintenanceMode({
        enabled,
      });
      dispatch('updateListFeatureFlags', data.response);
    } catch (err) {
      dispatch('handleError', err, {
        root: true,
      });
    } finally {
      commit('spinner', false, {
        root: true,
      });
    }
  },
  async manageReadMode({ dispatch, commit }, { enabled }) {
    try {
      commit('spinner', true, {
        root: true,
      });
      const { data } = await API.setReadOnlyMode({
        enabled,
      });
      dispatch('updateListFeatureFlags', data.response);
    } catch (err) {
      dispatch('handleError', err, {
        root: true,
      });
    } finally {
      commit('spinner', false, {
        root: true,
      });
    }
  },
  async setMaintenanceMessage({ dispatch, commit }, { text }) {
    try {
      commit('spinner', true, {
        root: true,
      });
      const { data } = await API.setMaintenanceMessage({
        text,
      });
      dispatch('updateListFeatureFlags', data.response);
    } catch (err) {
      dispatch('handleError', err, {
        root: true,
      });
    } finally {
      commit('spinner', false, {
        root: true,
      });
    }
  },
  updateListFeatureFlags({ commit, state }, { name, ...rest } = {
  }) {
    const { listFeatureFlags } = state;
    const newlistFeatureFlags = listFeatureFlags.map(flag => {
      return flag.name === name.toUpperCase() ? {
        ...flag,
        ...rest,
      } : flag;
    });
    commit('setListFeatureFlags', newlistFeatureFlags);
  },
};
